export default __webpack_public_path__ + "static/media/ScholarCourseImage2.a805a0b4.svg";